import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted} from 'vue';
import useClientState from '@/app/client/infrastructure/persistence/ClientState';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputClients',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const state = useClientState();



const clientOptions = ref<any[]>([]);

onMounted(async () => {
    clientOptions.value = await state.getAllSimple();
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": __props.modelValue,
    label: "Cliente",
    "item-title": "name",
    "item-value": "id",
    items: clientOptions.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["model-value", "items"]))
}
}

})